import { useEffect, useState } from "react";
import { HttpStatusCode } from "axios";
import { Form, TimePicker } from "antd";
import { WorkCalendarConstant } from "../../../core/_constant";
import { WorkCalendarService } from "../../../core/_request";
import { Loader } from "../../../../../../common/components/Loader/Loader";
import { FormProvider } from "../../../../../../common/provider/form/Form.provider";
import { SimpleInput } from "../../../../../../common/components/simpleInput";
import { CustomButton } from "../../../../../../common/components/CustomButton/CustomButton";
import { SchedulesInputs } from "./SchedulesInputs";

interface MainSchedulesProps {
  currentTab: string;
}

export const MainShedules = ({ currentTab }: MainSchedulesProps) => {
  const { RangePicker } = TimePicker;
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [isChanged, setIsChanged] = useState<boolean>(false);
  const [workSchedules, setWorkSchedules] = useState<any[]>([]);

  useEffect(() => {
    if (currentTab === "main") {
      getWorkTime(WorkCalendarConstant.WORK_ID);
    }
  }, [currentTab]);

  const getWorkTime = async (id: number) => {
    try {
      setIsLoading(true);
  
      const res = await WorkCalendarService.getWorkShedule(id);
  
      if (res.status === HttpStatusCode.Ok) {
        setWorkSchedules(res.data.workScheduleRulesArray);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        id: WorkCalendarConstant.WORK_ID,
        workScheduleRules: workSchedules.flatMap((day: any) =>
          day.times
            .filter((time: any) => time.startTime && time.endTime)
            .map((time: any) => {
              const item: any = {
                day: day.day["@id"],
                startTime: time.startTime,
                endTime: time.endTime,
              };
        
              if (time["@id"]) {
                item["@id"] = time["@id"];
              }
        
              return item;
            })
        ),
      };

      const res = await WorkCalendarService.patchWorkShedule(dataToPost);
      if (res?.status === HttpStatusCode.Ok) {
        setIsChanged(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <Loader isLoading={isLoading} />

      <FormProvider
        Form={Form}
        form={form}
        debug
        onFinish={(values: any) => {
          handleSubmit(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <SchedulesInputs
          value={workSchedules}
          onChange={setWorkSchedules}
          onChanged={() => setIsChanged(true)}
          canEmpty
        />
        <div className="mt-4">
          <CustomButton
            type="submit"
            variant="primary"
            disabled={!isChanged}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
